import './RegionTree.css';

// RegionNode component represents a single node in the region tree structure
const RegionNode = (prop) => {

  // Shows action buttons for a specific region node when clicked
  const showActionBtns = (elem, id) => {
    // Only show action buttons if user has edit permission
    if (!prop.canEdit) return;
    
    let elems = document.getElementsByClassName("rgn_edit_icon");
    for (let i = 0; i < elems.length; i++) {
      elems[i].classList.add("d-none");
    }
    document.getElementById("edit_btn" + id).classList.remove("d-none");
  }

  // Handle edit button click
  const handleEditClick = (e) => {
    e.stopPropagation(); // Prevent triggering showActionBtns
    if (prop.selectedId && prop.canEdit) {
      prop.selectedId(prop.id, 'EDIT', prop.keyVal, prop.regionTypeId);
    }
  }

  return (
    <div className="" onClick={() => showActionBtns(this, prop.id)}>
      {prop.text}
      {/* Only render edit icon if user has edit permission and selectedId handler exists */}
      {prop.canEdit && prop.selectedId && (
        <i 
          onClick={handleEditClick}
          title="Edit Region" 
          id={"edit_btn" + prop.id} 
          className={"fa d-none fa-pen ls-ms-2 rgn_edit_icon"} 
          role="button" 
          aria-hidden="true"
        />
      )}
    </div>
  );
};

export default RegionNode;